<template>
    <div>
<!--        "<strong>{{ $_.get(activity, "payload.name") }}</strong-->
<!--    >" task created by-->
<!--        <strong> {{ $_.get(activity, "actorUser.name") }}</strong>-->
        <span v-html="$t('notification.taskCreated', {user: $_.get(activity, 'actorUser.name'), task: $_.get(activity, 'payload.name') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "TaskCreated",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
